import { BottomItem } from '@appStore/reducers/leftSideMenu.ts'
import clearListIcon from 'assets/image/icons/left-side-menu/clear-list.svg'
import { Link } from 'react-router-dom'

import TooltipCustom from '../../../atoms/tooltipCustom'

interface ContactsMenuProps {
	active: null | number | string
	leftSide: {
		bottomList: BottomItem[]
		label?: string
		list?: any[]
	}
}

export function ContactsMenu({ active, leftSide }: ContactsMenuProps) {
	if (!leftSide.bottomList?.length) return null

	return (
		<>
			<Link
				className={`first-link text-list margin-top ${
					active === leftSide.bottomList[0].id ? 'active' : ''
				}`}
				to={leftSide.bottomList[0].link}
			>
				<div className="line-list__img-container">
					<img alt="pageIcon" src={leftSide.bottomList[0].image} />
				</div>
				{leftSide.bottomList[0].title}
			</Link>

			{leftSide.list && leftSide.list?.length > 0 && (
				<>
					<div className="recently-title">{leftSide.label}</div>
					<ul>
						{leftSide.list?.map(item => {
							return (
								!item.archived && (
									<li
										className={`${active === item.id ? 'active' : ''}`}
										key={item.id}
									>
										<Link
											className="text-list"
											to={`/contacts/import/${item.id}`}
										>
											<img
												alt="clockIcon"
												className="with-shift"
												src={clearListIcon}
											/>
											<TooltipCustom
												arrow={true}
												title={item.name.length > 24 ? item.name : ''}
											>
												<p
													className={
														item.name.length > 24
															? 'ellipsis'
															: 'left-list-text'
													}
												>
													{item.name}
												</p>
											</TooltipCustom>
										</Link>
									</li>
								)
							)
						})}
					</ul>
				</>
			)}
		</>
	)
}
